
/**
 * Check if a language is supported by the app
 */
export function isSupportedLanguage(languageCode) {
  const supportedLanguages = [
    'en', 'ko', 'hi', 'ja', 'zh', 'es', 'fr', 'de', 'ru', 'ar', 'pt', 'it',
    'nl', 'sv', 'da', 'no', 'fi', 'pl', 'tr', 'th', 'vi', 'id', 'ms'
  ];
  return supportedLanguages.includes(languageCode);
}